import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import { signin } from '../api/auth.js';
import { AuthContext } from '../context/AuthContextComponent';


export default function Signin() {
  const [errorMessage, setErrorMessage] = useState('')
  const navigate = useNavigate()
  const { isLoggedIn, setIsLoggedIn, user, setUser } = useContext(AuthContext)

  async function handleSubmit(e) {
    try {
      await signin(e.username, e.password)
      setIsLoggedIn(true)
      setUser(e.username)
      navigate('/home')
    } catch(error) {
      if (e.username === "") {
        setErrorMessage("Enter a username")
        return
      }
      if (e.password === "") {
        setErrorMessage("Enter a password")
        return
      }
      setErrorMessage(error.response.data.message)
    }
  }
  return (
    <div className="flex flex-col items-center justify-center max-w-6xl px-4 py-20  bg-white bg-opacity-80 px-4 py-2 rounded-md">
      {/* <h1 className="font-orbit">Welcome back to <span className="font-orbit">Curb</span><span className="font-orbit font-bold">IT</span></h1> */}
      <h1 className="text-3xl font-bold font-orbit mb-6 text-purple">Sign In</h1>
      <AuthForm onSubmit={handleSubmit} buttonText="SIGN IN" />
      <span className="mt-4">
        New to <span className="font-orbit">Curb</span><span className="font-orbit font-bold">IT</span>? <Link to="/auth/signup" className="text-purple hover:text-bubble-gum font-semibold">Sign Up</Link> instead.
      </span>
      <p className='mt-4 text-red font-bold'>{errorMessage}</p>
    </div>
  );
}